module.exports = __webpack_public_path__ + "img/logout.ee4c0a32.svg";